export default __webpack_public_path__ + "static/media/white-triangle.48084bf5.svg";